import { BLOCK_PREFIX } from './constants';

var count = 0;
var CLASS_NAME = "".concat(BLOCK_PREFIX, "-overflow-hidden");
var useLockScroll = function useLockScroll(isLock) {
  var lock = function lock() {
    if (isLock()) {
      !count && document.body.classList.add(CLASS_NAME);
      count++;
    }
  };
  var unlock = function unlock() {
    if (isLock() && count) {
      count--;
      !count && document.body.classList.remove(CLASS_NAME);
    }
  };
  return [lock, unlock];
};

export { useLockScroll };
